import { Caption, Icon, OverlineCardHeader } from '@if/mui'
import { Card, CardContent, Stack } from '@mui/material'
import { Info } from 'lucide-react'
import { ReactNode } from 'react'

interface Props {
  title: string
  children: ReactNode
  emptyMessage: string
  isReady: boolean
}

const WorksheetFundingSummaryCard = ({ title, children, emptyMessage, isReady }: Props) => {
  return (
    <Card>
      <OverlineCardHeader title={title} />
      <CardContent>
        {isReady ? (
          children
        ) : (
          <Stack spacing={1} alignItems="center" sx={{ py: 3 }}>
            <Icon icon={Info} color="primary" />
            <Caption sx={{ textAlign: 'center' }}>{emptyMessage}</Caption>
          </Stack>
        )}
      </CardContent>
    </Card>
  )
}

export default WorksheetFundingSummaryCard
